import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./components/ErrorWrapper/styles.module.scss";
const ErrorWrapper = (props) => {
  const errorWrapperClasses = classNames(props.errorText && styles[`error-wrapper--with-error`], props.className);
  return /* @__PURE__ */ jsxs("div", { className: errorWrapperClasses, "data-testid": props.testId, children: [
    props.errorText && /* @__PURE__ */ jsx("p", { className: styles["error-wrapper__errors"], id: props.errorTextId, children: props.errorText }),
    props.children
  ] });
};
export {
  ErrorWrapper as E
};
//# sourceMappingURL=ErrorWrapper.js.map
